/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M16.5427 6a.7473.7473 0 0 1-.0427-.25v-2c0-1.2426-1.0074-2.25-2.25-2.25H3.75C2.5074 1.5 1.5 2.5074 1.5 3.75v10.5c0 1.2426 1.0074 2.25 2.25 2.25H6v-1.25a.75.75 0 0 1 1.5 0v5c0 1.2426 1.0074 2.25 2.25 2.25h10.5c1.2426 0 2.25-1.0074 2.25-2.25V9.75c0-1.2426-1.0074-2.25-2.25-2.25h-4.3125a.7502.7502 0 0 1 0-1.5h.6052ZM20.25 6C22.3211 6 24 7.679 24 9.75v10.5c0 2.0711-1.6789 3.75-3.75 3.75H9.75C7.679 24 6 22.3211 6 20.25V18H3.75C1.679 18 0 16.3211 0 14.25V3.75C0 1.679 1.679 0 3.75 0h10.5C16.3211 0 18 1.679 18 3.75v2a.7473.7473 0 0 1-.0427.25H20.25Zm-8.0303 10.7197a.75.75 0 0 0 0 1.0606.75.75 0 0 0 1.0606 0l3.5304-3.5303-3.5304-3.5303a.75.75 0 0 0-1.2693.4022.7486.7486 0 0 0 .2087.6584l1.5411 1.5412c-.8762-.1664-1.6362-.4408-2.2944-.7879a7.2973 7.2973 0 0 1-.8303-.5114 7.2745 7.2745 0 0 1-1.2077-1.0839c-1.2737-1.428-1.8206-3.1475-1.9321-4.263a.75.75 0 0 0-1.4926.1493c.1385 1.385.7918 3.4153 2.3054 5.1121a8.7542 8.7542 0 0 0 1.8345 1.5618c.6373.4059 1.3586.7493 2.1711 1.0048.3697.1163.7583.2144 1.1664.2919.186.0353.376.0663.5702.0929l-1.8316 1.8316Z"
    clipRule="evenodd"
  />,
  'Clone'
);
